import {
  getAttachment,
  downloadAttachment,
  refreshCategoryItems,
} from './thunk';

import type { NoticeCategoryJson } from '@/types/domain/notice/entities/noticeCategoryEntity';
import type { CategoryItemsType } from '@/types/domain/notice/redux';
import type { Dispatch } from 'redux';

/**
 * React component初期化関数.
 * @param dispatch dispatch
 */
export const init = (
  dispatch: Dispatch<any>,
  nurseryId: string | undefined,
  _isInitCategoryItems: boolean,
) => {
  if (nurseryId) {
    // 開くたびにrefreshを実行する
    dispatch(refreshCategoryItems({ nurseryId }));
  }
};

/**
 * NoticeController
 */
export class NoticeController {
  private dispatch: Dispatch<any>;

  private nurseryId: string;

  private categoryList: NoticeCategoryJson[] = [];

  private categoryItems: CategoryItemsType;

  constructor(
    dispatch: Dispatch<any>,
    nurseryId: string,
    categoryList: NoticeCategoryJson[],
    categoryItems: CategoryItemsType,
  ) {
    this.dispatch = dispatch;
    this.nurseryId = nurseryId;
    this.categoryList = categoryList;
    this.categoryItems = categoryItems;
  }

  /**
   * getCategories
   * @returns カテゴリ
   */
  getCategories = () => [...this.categoryList]
    .sort((a, b) => (a.categoryIndex > b.categoryIndex ? 1 : -1));

  /**
   * getNoticeItems
   * @param categoryJson categoryJson
   * @returns 結果
   */
  getNoticeItems = (categoryJson: NoticeCategoryJson) => {
    const { categoryId, categoryItemCount } = categoryJson;
    const { items } = this.categoryItems[categoryId];
    const limit = items.length < categoryItemCount ? items.length : categoryItemCount;
    return {
      /** アイテムリスト */
      items,
      /** 上限 */
      limit,
    };
  };

  /**
   * getActionSetPreview
   * @param categoryId categoryId
   * @param key key
   * @returns 結果
   */
  getActionSetPreview = (categoryId: string | undefined, key: string | undefined) => {
    const setPreview = () => {
      if (categoryId && key) {
        const item = this.categoryItems[categoryId].items.find((v) => v.createDatetime === key);
        if (item) {
          this.dispatch(getAttachment({ item, nurseryId: this.nurseryId }));
          return;
        }
      }
      this.dispatch(getAttachment(undefined));
    };
    return setPreview;
  };

  /**
   * getActionDownload
   * @param categoryId categoryId
   * @param key key
   * @returns 結果
   */
  getActionDownload = (categoryId: string, key: string) => () => {
    const item = this.categoryItems[categoryId].items.find((v) => v.createDatetime === key);
    if (item) {
      this.dispatch(downloadAttachment({ item, nurseryId: this.nurseryId }));
    }
  };
}
